import { FindManyRankDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import { Loader, Select } from '@mantine/core'
import { GetInputPropsPayload } from '@mantine/form/lib/types'
import { toString } from 'lodash'
import useTranslation from 'next-translate/useTranslation'

const SelectRank = ({
  inputProps,
  required = false,
}: {
  inputProps: GetInputPropsPayload
  required: boolean
}) => {
  const { t } = useTranslation('common')
  const { data, loading } = useQuery(FindManyRankDocument)
  if (loading) return <Loader />
  return (
    <Select
      required={required}
      label={t('rank')}
      {...inputProps}
      searchable
      nothingFound={t('noOptions')}
      data={
        data?.findManyRank?.map(p => ({
          value: toString(p.id || '-'),
          label: p.title || '-',
        })) || []
      }
    />
  )
}

export default SelectRank
